// extracted by mini-css-extract-plugin
export default {"icon":"IconLink_icon__RYJSn"};